import { useMemo } from 'react';
import Image from '@components/Image';
import { Author } from '@interfaces/IUser';
import cn from 'classnames';
import css from './Avatar.module.less';
import { UserOutlined } from '@ant-design/icons';

interface AvatarProps<T extends Author> {
  user: T;
  className?: string;
  onClick?: () => void;
}

const Avatar = <T extends Author>({ user, className, ...rest }: AvatarProps<T>): JSX.Element => {
  const selectBorder: string = useMemo(() => {
    if (user?.isOfficial) {
      return css.verify;
    } else if (user?.isPlus) {
      return css.plus;
    } else if (!user?.enable) {
      return css.enable;
    } else {
      return css.root;
    }
  }, [user]);

  if (user?.image?.url) {
    return (
      <Image
        className={cn(css.root, className, selectBorder)}
        url={user?.image?.url || ''}
        alt=''
        {...rest}
      />
    );
  } else {
    return (
      <span
        className={cn(css.root, className, selectBorder)}
        {...rest}
      >
        <UserOutlined />
      </span>
    );
  }
};

export default Avatar;
